import React from 'react';

import PropTypes from 'prop-types';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

export const ModalError = (props) => {
    return (
        <ModalComponent isVerticalCentered canCloseModal={props.canCloseModal} isIconClose linkTo={props.linkTo}>
            <InfoPage
                insideModalComponent
                animatedIconFail
                mainText={props.mainText}
                headerText={props.headerText}
                secondaryText={props.secondaryText}
                topButtonType="link"
                topButtonCaption={props.topButtonCaption}
                topButtonLink={props.topButtonLink}
                primaryButtonType="button"
                primaryButtonCaption={props.primaryButtonCaption}
                primaryButtonOnClick={props.primaryButtonOnClick}
                buttonRowType="button"
                buttonRowCaption={props.buttonRowCaption}
                buttonRowOnClick={props.buttonRowOnClick}
            />
        </ModalComponent>
    );
};
ModalError.propTypes = {
    headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    mainText: PropTypes.string,
    topButtonCaption: PropTypes.string,
    topButtonLink: PropTypes.string,
    primaryButtonCaption: PropTypes.string,
    primaryButtonOnClick: PropTypes.func,
    buttonRowCaption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttonRowOnClick: PropTypes.func,
};

export default ModalError;
